export const navLinks = [
    { name: "About", href: "#about" },
    { name: "Skills", href: "#skills" },
    { name: "Projects", href: "#projects" },
    { name: "Experience", href: "#experience" },
    { name: "AI Chat", href: "#ai-chat" },
    { name: "Certs", href: "#certifications" },
    { name: "Roles", href: "#roles" },
    { name: "Resume", href: "#resume" },
    { name: "Contact", href: "#contact" },
];

export const projects = [
    {
        title: "Tar Cloud",
        description: "A self-hosted personal cloud platform that aggregates everyday services (storage, QR generator, file converter, URL shortener, Linktree, and more). Portfolio is deployed at cloud.tarush.in.",
        techStack: ["Self-hosted", "Ubuntu", "Docker", "Nginx", "Bash"],
        githubLink: "https://github.com/tarush10000/tar-cloud-infra",
        liveLink: "https://cloud.tarush.in",
        details: "Tar Cloud is a personal cloud platform I built on an old Ubuntu laptop to host multiple small services I use daily—avoiding third-party limits and ads. The platform currently serves this portfolio and will expand to include storage, converters, URL shorteners, and more."
    },
    {
        title: "AudioMind",
        description: "Full-stack audio analysis tool using Whisper, pyannote, and NER for intelligent audio insights.",
        techStack: ["Python", "Whisper.cpp", "Pyannote", "NER", "FastAPI", "React", "MongoDB"],
        githubLink: "https://github.com/tarush10000/AudioMind",
        // liveLink: "https://audiomind-demo.vercel.app",
        details: "AudioMind is an advanced platform designed for comprehensive audio analysis. It integrates cutting-edge technologies like OpenAI's Whisper for highly accurate speech-to-text transcription, Pyannote for speaker diarization (identifying who spoke when), and Named Entity Recognition (NER) to extract key entities from the transcribed text."
    },
    {
        title: "SatIndustry",
        description: "Air pollution forecasting system using LSTM networks combined with Kalman filters for improved accuracy.",
        techStack: ["Python", "Django", "Sentinel", "Leaflet.JS", "TensorFlow", "Keras", "LSTM", "Kalman Filter", "D3.js"],
        githubLink: "https://github.com/tarush10000/SatIndustry",
        details: "SatIndustry addresses the critical issue of air pollution by providing accurate forecasts using hybrid LSTM and Kalman Filter models trained on historical pollution and meteorological data."
    },
    {
        title: "ProDev.AI",
        description: "Developer productivity tool leveraging Gemini API for intelligent software planning and task automation.",
        techStack: ["Python", "Gemini API", "React", "Node.js", "Express.js", "MongoDB"],
        githubLink: "https://github.com/tarush10000/ProDev.AI",
        details: "ProDev.AI enhances developer workflow by integrating LLMs via Gemini API for task breakdown, code generation, and workflow optimization."
    },
    {
        title: "InstructAI",
        description: "AI-powered learning platform that revolutionizes education with personalized study experiences, interactive content, and adaptive assessments.",
        techStack: ["Python", "Django", "AI/ML", "JavaScript", "HTML", "CSS", "SQLite"],
        githubLink: "https://github.com/tarush10000/InstructAI",
        details: "InstructAI is an innovative learning platform developed by a team of 6 for IT Project Management subject. It tackles traditional learning challenges by offering AI-driven solutions including intelligent note generation, interactive video creation, adaptive quizzes, progress tracking, and AI mock interviews. The platform provides personalized learning experiences tailored to individual pace and style, making education more engaging and efficient. Built with secure and scalable infrastructure to ensure reliable learning environment for students and professionals.",
    }
];

export const skills = {
    "Languages": ["Python", "Java", "JavaScript", "C++", "C", "SQL", "Dart (Flutter)"],
    "Web Development": ["React", "Typescript", "Next.js", "Django", "Node.js", "Express.js", "jQuery", "HTML", "CSS", "Bootstrap", "Tailwind CSS"],
    "Cloud & DevOps": ["AWS (EC2, S3, IAM, RDS, CloudWatch, Lambda)", "Docker", "Git", "GitHub", "Postman"],
    "Databases": ["MongoDB", "MySQL", "SQLite", "Firebase"],
    "AI/ML Tools": [
        "whisper.cpp",
        "pyannote.audio",
        "Gemini API",
        "Transformers (Hugging Face)",
        "LangChain",
        "LLM Agents",
        "FAISS",
        "sentence-transformers",
        "chromadb",
        "TensorFlow/Keras"
    ],
    "Core Skills": ["Data Structures & Algorithms", "Database Management System (DBMS)", "Operating Systems", "Computer Networks", "Object-Oriented Programming", "Cloud Architecture", "RAG & LLMs", "Team Leadership", "Project Management"]
};

export const experiences = [
    {
        role: "Software Engineer Intern",
        company: "Caterpillar Inc.",
        duration: "Jan 2026 - July 2026",
        description: "Working as a Software Engineer at Caterpillar Inc., building robust software solutions and collaborating across teams to deliver scalable enterprise applications."
    },
    {
        role: "Software Developer Intern",
        company: "Sooru.AI",
        duration: "May 2025 - Dec 2025",
        description: "Built immersive frontend experiences for architectural floor planning using Three.js, creating 20+ interactive visualization tools and optimizing rendering performance by 40% for seamless 3D room design workflows."
    },
    {
        role: "Web Lead",
        company: "The Indian Vidyarthi",
        duration: "Jan 2024 - Dec 2024",
        description: "Led website revamp with modern UI/UX, achieving 35% increase in user engagement."
    },
    {
        role: "Frontend Developer Intern",
        company: "Valsco Technology",
        duration: "May 2024 - July 2024",
        description: "Developed dynamic alumni chat system using MongoDB and React, enhancing user engagement."
    },
];

export const certifications = [
    {
        name: "AWS Certified Cloud Practitioner",
        issuer: "Amazon Web Services",
        description: "Validated expertise in AWS cloud architecture, billing, and security practices; showcased ability to design cost-efficient and secure solutions across global infrastructure."
    },
    {
        name: "Oracle Java Certified Foundations Associate",
        issuer: "Oracle",
        description: "Scored in top 10 percentile globally; built algorithmic solutions using Java fundamentals, JDK, and JRE frameworks to solve real-world programming challenges."
    },
    {
        name: "Oracle OCI Generative AI Certified Professional",
        issuer: "Oracle",
        description: "Demonstrated mastery in deploying LLMs, designing RAG pipelines, and building AI chatbots; certified for leveraging OCI tools in production-ready AI applications."
    },
    {
        name: "Special Mention Award - Caterpillar Hackathon",
        issuer: "Caterpillar Inc.",
        description: "Among top 5 teams from 150+ participants; created CATFix, a voice-enabled AI platform using Web Speech API, OCR, and Gemini AI to streamline technician workflows."
    },
    {
        name: "3rd Prize - 48-Hour DEVSOC Hackathon",
        issuer: "VIT Vellore",
        description: "Secured 3rd position among 2000+ participants nationwide; developed ProDev.AI 2, an AI-powered tool using Gemini API and RAG for automating software documentation."
    }
];

export const roles = [
    {
        title: "Cisco Campus Ambassador",
        duration: "2024 – 2025",
        description: "Representing Cisco on campus, organizing tech events, and fostering engineering community."
    },
    {
        title: "Chairperson, IEEE TEMS VIT",
        duration: "2025",
        description: "Leading IEEE Technology & Engineering Management Society chapter, overseeing events and workshops."
    },
];
